import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IndexeddbService {

  private dbName: string = 'monanewjoboffer';
  private storeName: string = 'newjoboffer';
  autoSaveConditionalWorkflow: any = {};
  autoSaveFlowcharts: any = [];
  autoSaveMessages: any = [];
  autoSaveMessageNodes: any = [];

  constructor() { 
    this.openDb();
  }

  openDb() {
    // alert('openIndexedDb');
    const request = indexedDB.open(this.dbName, 1);
    request.onupgradeneeded = (event) => {
      const db = request.result;
      db.createObjectStore(this.storeName, { keyPath: 'id' });
    }

    request.onsuccess = (event) => {
      console.log('Database opened successfully');
      this.getInitData();
    }

    request.onerror = (event) => {
      console.log('Database error: ' + request.error);
    }
  }

  updateAutoSaveFlowchart(form: any, isAutomaticCV, messageNodes: any[]) {

    console.log("updateAutoSaveFlowchart form", messageNodes);

    const autoSaveConditionalWorkflow = form.conditionalWorkflow || {};
    const autoSaveFlowcharts = form.flowcharts || [];
    let autoSaveMessages = form.messages || [];

    if(isAutomaticCV)
    {

      autoSaveMessages = autoSaveMessages.filter((message) => {
        return message.value !== 'Danke' && message.value !== 'Sprache' && message.value !== 'Ende' && message.value !== 'Vertrag' && message.value !== 'Q&A';
      });
  
    }
    else
    {

      autoSaveMessages = autoSaveMessages.filter((message) => {
        return message.value !== 'Danke' && message.value !== 'Sprache' && message.value !== 'Ende' && message.value !== 'Vertrag' && message.value !== 'Q&A' && message.value !== 'CV Upload';
      });
  
    }

    autoSaveMessages.forEach((message) => {
      delete message.languages;
    });

    console.log("############>>>>>>>>>>>>>>autoSaveMessages", autoSaveMessages);



    const refMessages = [];
    autoSaveMessages.forEach((message) => {
      refMessages.push(message);
    });
    autoSaveMessages = [];

    console.log("refMessages", refMessages);
    messageNodes.forEach(messageNode => {
      if(messageNode.label != "End Session" && messageNode.label != "Start")
      {
        const message = refMessages.find(msg => msg.parameterMap['deutsch'] == messageNode.parameterMap['deutsch'] || msg.languageMap['deutsch'] == messageNode.languageMap['deutsch']);
        if(message)
        {
          autoSaveMessages.push(message);
        }
        else
        {
          console.log("!!!!!!!!!!!!!!!!can not find message", messageNode);
          const message2 = messageNodes.find(msg => msg.parameterMap['deutsch'] == messageNode.parameterMap['deutsch'] || msg.languageMap['deutsch'] == messageNode.languageMap['deutsch']);
          if(message2)
          {
            autoSaveMessages.push(message2);
          }
          else
          {
            console.log("!!!!!!!!!!!!!!!!can not find message", messageNode);
          }
        }
      }
    });

    console.log("messages", autoSaveMessages);


    const request = indexedDB.open(this.dbName, 1);
    request.onsuccess = (event) => {
      const db = request.result;
      const transaction = db.transaction(this.storeName, 'readwrite');
      const store = transaction.objectStore(this.storeName);
      store.put({ id: 1, data: {
        autoSaveConditionalWorkflow: autoSaveConditionalWorkflow,
        autoSaveFlowcharts: autoSaveFlowcharts,
        autoSaveMessages: autoSaveMessages,
        autoSaveMessageNodes: messageNodes
      }});
    }
  }

  async getInitData() {
    const request = indexedDB.open(this.dbName, 1);
    request.onsuccess = (event) => {
      const db = request.result;
      const transaction = db.transaction(this.storeName, 'readonly');
      const store = transaction.objectStore(this.storeName);
      const getRequest = store.getAll();
      getRequest.onsuccess = (event) => {
        if(getRequest.result[0].data == undefined) {
              
          store.add({ id: 1, data: {
            autoSaveConditionalWorkflow: {},
            autoSaveFlowcharts: [],
            autoSaveMessages: [],
            autoSaveMessageNodes: []
          }});
        }
      }
    }
  }

  async getData() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName, 1);
      
      request.onsuccess = (event) => {
        const db = request.result;
        const transaction = db.transaction(this.storeName, 'readonly');
        const store = transaction.objectStore(this.storeName);
        const getRequest = store.getAll();  // 获取所有数据
  
        getRequest.onsuccess = (event) => {
          const result = getRequest.result;
          if (result.length > 0 && result[0].data !== undefined) {
            // console.log(result[0].data);  // 打印当前的数据
            resolve(result[0].data);  // 返回获取的数据
          } else {
            reject((event.target as IDBRequest).error);
          }
        };
  
        getRequest.onerror = (event) => {
          reject((event.target as IDBRequest).error);
        };
      };
  
      request.onerror = (event) => {
        reject((event.target as IDBRequest).error);
      };
    });
  }
  

}
